import React, { useEffect } from "react"
import { Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { DataGrid } from "@material-ui/data-grid"
import { DeleteOutline } from "@material-ui/icons"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
// Data
import { deleteImage, getImages } from "../../redux/apiCalls"
// Styles
// Styles
import {
   Container,
   GridWrapper,
   Main,
   Wrapper,
   StyledLink,
   StyledButton,
   StyledIcon,
   Action,
   TitleWrapper,
   Title,
   TitleButton,
} from "./ImageList.styles"

const ImageList = () => {
   const dispatch = useDispatch()
   const images = useSelector((state) => state.image.images)

   useEffect(() => {
      getImages(dispatch)
   }, [dispatch])

   const handleDelete = (id) => {
      deleteImage(id, dispatch)
   }

   const columns = [
      { field: "_id", headerName: "ID", width: 210 },
      { field: "section", headerName: "Section", width: 140 },
      { field: "name", headerName: "Name", width: 210 },
      {
         field: "action",
         headerName: "Action",
         width: 180,
         renderCell: (params) => {
            return (
               <Action>
                  <StyledLink to={"/image/" + params.row._id}>
                     <StyledButton>Edit</StyledButton>
                  </StyledLink>
                  <StyledIcon>
                     <DeleteOutline
                        onClick={() => handleDelete(params.row._id)}
                        color="secondary"
                     />
                  </StyledIcon>
               </Action>
            )
         },
      },
   ]

   const validImages = images.filter((image) => image && image._id)

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>Images List</Title>
                  <Link to="/newImage">
                     <TitleButton>Create</TitleButton>
                  </Link>
               </TitleWrapper>
               <GridWrapper>
                  <DataGrid
                     rows={validImages}
                     columns={columns}
                     sortModel={[{ field: "name", sort: "asc" }]}
                     initialState={{
                        sorting: {
                           sortModel: [{ field: "name", sort: "asc" }],
                        },
                     }}
                     getRowId={(row) => row?._id}
                     disableSelectionOnClick
                     pageSize={50}
                     checkboxSelection
                     autoHeight
                  />
               </GridWrapper>
            </Main>
         </Container>
      </>
   )
}

export default ImageList
